<mat-paginator #paginator [length]="100"
              [pageSize]="10"
              [pageSizeOptions]="[5, 10, 25, 100]"
              aria-label="Select page" 
              class="paginator-v2">
</mat-paginator>